import { useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, Package, User, Bell } from 'lucide-react';
import { useNotifications } from '../contexts/NotificationContext';

const items = [
  { key: 'home', to: '/', label: 'Home', icon: Home, match: (path) => path === '/' || path === '/home' },
  { key: 'browse', to: '/products', label: 'Browse', icon: Search },
  { key: 'orders', to: '/orders', label: 'Orders', icon: Package },
  { key: 'alerts', to: '/notifications', label: 'Alerts', icon: Bell },
  { key: 'profile', to: '/profile', label: 'Profile', icon: User },
];

const TAB_STATE_KEY = 'pwa_tab_state';

const saveTabState = (path) => {
  const match = items.find((item) => path.startsWith(item.to));
  if (!match) return;
  const next = JSON.parse(localStorage.getItem(TAB_STATE_KEY) || '{}');
  next[match.key] = path;
  localStorage.setItem(TAB_STATE_KEY, JSON.stringify(next));
};

export default function PwaBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { unreadCount } = useNotifications();

  const navItems = [...items];


  const getTabTarget = (item) => {
    if (item.key === 'home') return '/';
    try {
      const stored = JSON.parse(localStorage.getItem(TAB_STATE_KEY) || '{}');
      return stored[item.key] || item.to;
    } catch {
      return item.to;
    }
  };

  const haptic = () => {
    if (window.navigator?.vibrate) {
      window.navigator.vibrate(8);
    }
  };

  if (typeof window !== 'undefined') {
    // keep tab state current
  }

  useEffect(() => {
    saveTabState(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <nav className="pwa-only pwa-bottom-nav" aria-label="Primary">
      <div className="pwa-bottom-nav__inner">
        {navItems.map(({ key, to, label, icon: Icon, match }) => (
          <NavLink
            key={key}
            to={to}
            className={({ isActive }) => {
              const pathname = location.pathname;
              const isExact = match
                ? match(pathname)
                : isActive || (to !== '/' && pathname.startsWith(to));
              return `pwa-bottom-nav__item${isExact ? ' is-active' : ''}`;
            }}
            onClick={(event) => {
              event.preventDefault();
              haptic();
              const target = getTabTarget({ key, to });
              navigate(target);
            }}
          >
            <span className="pwa-bottom-nav__icon-wrap">
              <Icon className="pwa-bottom-nav__icon" />
              {key === 'alerts' && unreadCount > 0 && (
                <span className="pwa-bottom-nav__badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
              )}
            </span>
            <span className="pwa-bottom-nav__label">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
